import {objectToQueryString} from './object-to-query-string';

export const buildUrlWithQueryParameters = (
    origin: string,
    queryParameters: {[k: string]: string | number} = {},
): string => {
    const queryParamsString = objectToQueryString(queryParameters);

    return `${origin}${queryParamsString ? `?${queryParamsString}` : ''}`;
};
